<div id="content" [formGroup]="filter_form">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title">
          <h1>{{ page_title }}</h1>

          <mat-form-field appearance="outline" style="width: 240px">
            <span matPrefix class="ml-3 mr-1"><mat-icon>person</mat-icon></span>
            <input
              [formControl]="user_autocomplete_control"
              type="text"
              placeholder="Buscar usuario..."
              matInput
              [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnUser" (optionSelected)="onUserAutocompleteSelected($event)">
              @for (user of users_filtered(); track user) {
                <mat-option [value]="user">{{ user.name + ' ' + user.surnames }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100px">
            <mat-label>Período</mat-label>
            <mat-select panelWidth formControlName="period">
              @for (period of periods(); track period) {
                <mat-option [value]="period">{{ period }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 card">
        <div class="bisual-table">
          <div class="bisual-table-row-header">
            <div class="bisual-table-col">Id</div>
            <div class="bisual-table-col">Tipo</div>
            <div class="bisual-table-col">Fecha</div>
            <div class="bisual-table-col">Ubicación</div>
            <div class="bisual-table-col"></div>
          </div>
          @for (clock of clock_registers(); track clock) {
            <div class="bisual-table-row">
              <div class="bisual-table-col">#{{ clock.id }}</div>
              <div class="bisual-table-col clock-type-cell">
                @if (clock.semaforoClass) {
                  <div class="semaforo" [class]="clock.semaforoClass" matTooltip="Descanso"></div>
                }
                <span>{{ clock.type === 'out' ? 'Salida' : 'Entrada' }}</span>
                <mat-icon class="clock-icon" [attr.data-type]="clock.type">trending_flat</mat-icon>
                @if (clock.is_location_remote) {
                  @if (clock.should_be_from_office) {
                    <span class="info-emoji" matTooltip="Fuera de la oficina, y no debería">
                      🏢
                      <span class="suffix-info-emoji">❌</span>
                    </span>
                  } @else {
                    <span matTooltip="Fuera de la oficina">🏡</span>
                  }
                }
                @if (clock.device === 'mobile') {
                  <span matTooltip="Desde el móvil">📱</span>
                }
              </div>
              <div class="bisual-table-col">{{ clock.created_at | date: 'short' }}</div>
              <div class="bisual-table-col">
                @if (clock.location?.name || clock.location_ip?.location?.name; as location_name) {
                  <button
                    type="button"
                    mat-button
                    class="location-button"
                    matTooltip="Ver ubicación en el mapa"
                    (click)="openLocationDialog(clock)"
                  >
                    <mat-icon>place</mat-icon>
                    <span>{{ location_name }}</span>
                  </button>
                } @else {
                  —
                }
              </div>
              <div class="bisual-table-col">
                <div class="actions-cell">
                  <button
                    mat-icon-button
                    [disabled]="!clock.latest_review_request"
                    matTooltip="Estado de aprobación"
                    (click)="openApprovalStatusDialog(clock.latest_review_request!)"
                  >
                    <mat-icon>info</mat-icon>
                  </button>
                  <span
                    [matTooltip]="
                      clock.latest_review_request?.status === employee_request_responsible_for_answer_status_enum.PENDING
                        ? 'Pendiente de revisión'
                        : clock.latest_review_request?.status === employee_request_responsible_for_answer_status_enum.ACCEPTED
                          ? 'Cambio aceptado, volver a solicitar cambio'
                          : clock.latest_review_request?.status === employee_request_responsible_for_answer_status_enum.REJECTED
                            ? 'Cambio rechazado, volver a solicitar cambio'
                            : 'Solicitar cambio'
                    "
                    [matTooltipDisabled]="
                      clock.journal_clock_type !== clock_register_journal_clock_type_enum.SCHEDULE &&
                      clock.latest_review_request?.status !== employee_request_responsible_for_answer_status_enum.PENDING
                    "
                  >
                    <button
                      mat-icon-button
                      [disabled]="
                        clock.journal_clock_type !== clock_register_journal_clock_type_enum.SCHEDULE ||
                        clock.latest_review_request?.status === employee_request_responsible_for_answer_status_enum.PENDING
                      "
                      (click)="requestReview(clock)"
                    >
                      <mat-icon [class]="'status-' + (clock.latest_review_request?.status ?? 'empty')">manage_history</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
